import classNames from 'classnames';

const sizeMapping = {
  small: 'sui-text-xs',
  base: 'sui-text-sm'
};

const variantMapping = {
  outline: {
    colors: ['primary', 'inverse', 'medium', 'brand', 'info', 'success', 'warning', 'danger']
  },
  regular: {
    colors: ['primary', 'medium', 'brand', 'info', 'success', 'warning', 'danger']
  },
  strong: {
    colors: ['primary', 'inverse', 'medium', 'brand', 'info', 'success', 'warning', 'danger']
  }
};

const badgeClasses = {
  outline: ({ color }) => classNames('sui-font-bold sui-leading-tight sui-border-1 sui-border-solid sui-rounded-base sui-bg-transparent', {
    'sui-text-primary sui-border-strongest': color === 'primary',
    'sui-text-inverse sui-border-inverse': color === 'inverse',
    'sui-text-medium sui-border-strong': color === 'medium',
    'sui-text-brand sui-border-accent': color === 'brand',
    'sui-text-info sui-border-info-subtle': color === 'info',
    'sui-text-success sui-border-success-subtle': color === 'success',
    'sui-text-warning sui-border-warning-subtle': color === 'warning',
    'sui-text-danger sui-border-danger': color === 'danger'
  }),
  regular: ({ color }) => classNames('sui-font-bold sui-leading-tight sui-rounded-base', {
    'sui-bg-primary sui-text-primary': color === 'primary',
    'sui-bg-strong sui-text-medium': color === 'medium',
    'sui-bg-brand-subtle sui-text-badge-accent-brand-regular': color === 'brand',
    'sui-bg-info sui-text-badge-accent-teal-regular': color === 'info',
    'sui-bg-success sui-text-badge-accent-green-regular': color === 'success',
    'sui-bg-warning-subtle sui-text-badge-accent-yellow-regular': color === 'warning',
    'sui-bg-danger sui-text-badge-accent-red-regular': color === 'danger'
  }),
  strong: ({ color }) => classNames('sui-font-bold sui-leading-tight sui-rounded-base', {
    'sui-text-inverse sui-bg-inverse': color === 'primary',
    'sui-text-primary sui-bg-primary': color === 'inverse',
    'sui-text-inverse sui-bg-medium': color === 'medium',
    'sui-text-inverse sui-bg-brand': color === 'brand',
    'sui-text-inverse sui-bg-info-strongest': color === 'info',
    'sui-text-inverse sui-bg-success-strongest': color === 'success',
    'sui-text-primary sui-bg-warning': color === 'warning',
    'sui-text-inverse sui-bg-danger-strongest': color === 'danger'
  })
};

const textColors = {
  outline: (color) => {
    switch (color) {
      case 'primary':
        return 'primary';
      case 'inverse':
        return 'inverse';
      case 'medium':
        return 'medium';
      case 'brand':
        return 'brand';
      case 'info':
        return 'info';
      case 'success':
        return 'success';
      case 'warning':
        return 'warning';
      case 'danger':
        return 'danger';
      default:
        return 'primary';
    }
  },
  regular: (color) => {
    switch (color) {
      case 'primary':
        return 'primary';
      case 'medium':
        return 'medium';
      case 'brand':
        return 'none';
      case 'info':
        return 'none';
      case 'success':
        return 'none';
      case 'warning':
        return 'none';
      case 'danger':
        return 'none';
      default:
        return 'primary';
    }
  },
  strong: (color) => {
    if (color === 'inverse' || color === 'warning') {
      return 'primary';
    }
    return 'inverse';
  }
};

export default function createBadge({
  color: colorProp = 'primary',
  variant: variantProp,
  size = 'base',
}) {

  const variant = variantMapping[variantProp] !== undefined ? variantProp : 'strong';
  const { colors } = variantMapping[variant];

  const color = colors.indexOf(colorProp) !== -1 ? colorProp : colors[0];

  const badgeClass = badgeClasses[variant]?.({ color });
  const textColor = textColors[variant]?.(color);

  const classes = `${badgeClass} ${sizeMapping[size]}`;

  return {
    classes,
    textColor
  };
}
